import React, { useContext } from 'react'
import * as dayjs from 'dayjs'

import { AuthContext } from '../../../context/authProvider'
import { useTranslation } from '../../../context/translationProvider'

import { If } from '../../atoms/if'
import { Button } from '../../atoms/button'
import { FormatAmount } from '../../atoms/formatAmount'

import ExclamationIcon from '../../../images/icon_exclamation_circle.svg'
import {
  Bold,
  ButtonWrapper,
  Col,
  Error,
  Row,
  Wrapper,
  StatusColor,
} from './styles'

export const Receipt = ({ data, onClose }) => {
  const { translate } = useTranslation()
  const { status, date, fees, amount } = data

  const { user } = useContext(AuthContext)

  return (
    <Wrapper>
      <If
        condition={
          status.toLowerCase() === 'success' ||
          status.toLowerCase() === 'pending'
        }
        render={() => (
          <>
            <Row>
              <Bold>
                <span>{translate('payments.receipt.date')}</span>
              </Bold>
              <Col align="right">{dayjs(date).format('DD.MM.YYYY HH:mm')}</Col>
            </Row>
            <Row>
              <Bold>
                <span>{translate('payments.receipt.amount')}</span>
              </Bold>
              <Col align="right">
                <FormatAmount
                  amount={amount}
                  shortCode={user?.wallet?.currency?.short_code}
                  currencySymbol={user?.wallet?.currency?.symbol}
                />
              </Col>
            </Row>
            <Row>
              <Bold>
                <span>{translate('payments.receipt.fee')}</span>
              </Bold>
              <Col align="right">
                <FormatAmount
                  amount={fees ? fees?.amount : 0}
                  shortCode={user?.wallet?.currency?.short_code}
                  currencySymbol={user?.wallet?.currency?.symbol}
                />
              </Col>
            </Row>
            <Row>
              <Bold>
                <span>{translate('payments.receipt.balance')}</span>
              </Bold>
              <Col align="right">
                <FormatAmount
                  amount={user.wallet.amount}
                  shortCode={user?.wallet?.currency?.short_code}
                  currencySymbol={user?.wallet?.currency?.symbol}
                />
              </Col>
            </Row>
            <Row>
              <Bold>
                <span>{translate('payments.receipt.status')}</span>
              </Bold>
              <StatusColor status={status.toLowerCase()} align="right">
                {translate(`payments.receipt.statuses.${status.toLowerCase()}`)}
              </StatusColor>
            </Row>
            <ButtonWrapper>
              <Button onClick={onClose} id="receipt-close-button">
                {translate('common.close')}
              </Button>
            </ButtonWrapper>
          </>
        )}
      />

      <If
        condition={
          status.toLowerCase() === 'error' ||
          status.toLowerCase() === 'cancelled' ||
          status.toLowerCase() === 'declined'
        }
        render={() => (
          <Error>
            <img src={ExclamationIcon} alt="Error" width={30} height={30} />
            <span>{translate('payments.receipt.error')}</span>
          </Error>
        )}
      />
    </Wrapper>
  )
}
